import WatchListUpdateReportTable from './WatchListUpdateReportTable';

export default WatchListUpdateReportTable;


// WEBPACK FOOTER //
// ./src/features/reports/pages/watch-list-update-report/table/index.js